<template>
    <div>
        <div class="mb-4 text-right">
            <button class="btn btn-sm btn-primary" @click="link">
                <i class="fas fa-plus mr-2"></i>
                New
            </button>
        </div>

        <card>
            <card-header>
                Healthjump Integrations
            </card-header>
            <card-body class="pt-0">
                <card-spinner
                    v-if="loading"
                    style="height: 240px;"
                />

                <table v-else class="table mb-0 table-hover">
                    <thead>
                    <tr>
                        <th>Client id</th>
                        <th>Client name</th>
                        <th>Company</th>
                        <th>Location</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in integrations" :key="item.id">
                        <td>{{ item.client_id }}</td>
                        <td>{{ item.client }}</td>
                        <td>{{ item.location.team }}</td>
                        <td>{{ item.location.name }}</td>
                        <td class="text-right">
                            <button class="btn btn-danger btn-sm"
                                @click="unlink(item)"
                                v-if="item.location.id">
                                Unlink
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <pagination :meta="integrationPaginationData.meta" :links="integrationPaginationData.links" @page="fetchData"/>
            </card-body>
        </card>

        <modal ref="modal" size="lg">
            <template slot="title">
                Link client with location(s)
            </template>

            <div class="form-group">
                <label for="client">Healthjump Client</label>
                <multiselect
                    :class="{'is-invalid': form.errors.has('client')}"
                    id="clients"
                    track-by="client_id"
                    label="client"
                    v-model="form.client"
                    placeholder="Type to search"
                    :options="clients"
                    :searchable="true"
                />
                <div class="invalid-feedback" v-if="form.errors.has('client')">
                    {{ form.errors.get('client') }}
                </div>
            </div>

            <div class="form-group">
                <label for="company">Swell Company</label>
                <multiselect
                    :class="{'is-invalid': form.errors.has('team')}"
                    id="company"
                    track-by="id"
                    label="name"
                    v-model="form.team"
                    placeholder="Type to search"
                    :options="companies"
                    :searchable="true"
                    :disabled="form.client === null"
                    :loading="companyLoading"
                    @search-change="fetchTeams"
                />
                <div class="invalid-feedback" v-if="form.errors.has('team')">
                    {{ form.errors.get('team') }}
                </div>
            </div>

            <div class="form-group">
                <label for="location">Location</label>
                <multiselect
                    :class="{'is-invalid': form.errors.has('locations') || form.errors.has('locations.0.id')}"
                    id="location"
                    track-by="id"
                    label="name"
                    v-model="form.locations"
                    placeholder="Type to search"
                    :multiple="true"
                    :close-on-select="false"
                    :hide-selected="true"
                    :options="locations"
                    :searchable="true"
                    :loading="locationLoading"
                    :disabled="form.team === null"
                    @search-change="fetchLocations"
                />
                <div class="invalid-feedback" v-if="form.errors.has('locations')">
                    {{ form.errors.get('locations') }}
                </div>
                <div class="invalid-feedback" v-if="form.errors.has('locations.0.id')">
                    <ul class="alert alert-danger">
                        <li v-for="(error, index) in form.errors.all()" :key="index">
                            {{ error }}
                        </li>
                    </ul>
                </div>
            </div>

            <template slot="footer">
                <button class="btn btn-default" type='button' data-dismiss='modal'>
                    Cancel
                </button>
                <button class="btn btn-primary" @click="save">
                    Link
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form(),
                loading: false,
                integrations: [],
                clients: [],
                companies      : [],
                companyLoading : false,
                locations      : [],
                locationLoading: false,
                integrationPaginationData: [],
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            async fetchClients() {
                let {data} = await this.$http.get(this.$laroute.route('spark.kiosk.healthjump.clients'));
                this.clients = data;
            },

            async fetchData(page = 1) {
                this.loading      = true;
                let params = {page: page};
                let {data}        = await this.$http.get(this.$laroute.route('spark.kiosk.healthjump-integration.index'), {params});
                this.loading      = false;
                this.integrations = data.data;
                this.integrationPaginationData = data;

            },

            async fetchTeams(query) {
                this.companyLoading  = true;
                let params           = {search: query};
                let {data}           = await this.$http.get(this.$laroute.route('api.teams.light'), {params});
                this.companies       = data;
                this.companyLoading  = false;
            },

            async fetchLocations(query) {
                this.locationLoading = true;
                let params           = {search: query, team_id: this.form.team.id};
                let {data}           = await this.$http.get(this.$laroute.route('api.locations.light'), {params});
                this.locations       = data;
                this.locationLoading = false;
            },

            link() {
                this.form   = new Form({
                    client   : null,
                    team     : null,
                    locations: []
                });
                this.fetchClients();
                this.$refs.modal.open();
            },

            async unlink(client) {
                this.$confirm({confirmButtonText: 'Yes, unlink it!'})
                    .then(() => {
                        this.$http.delete(this.$laroute.route('spark.kiosk.healthjump-integration.destroy', {
                            healthjump_integration: client.id
                        }))
                        .then(() => {
                            this.$alert({
                                message: 'Unlink successful.',
                                type: 'success',
                                title: 'Success!'
                            })
                            .then(() => {
                                this.fetchData();
                            })
                        })
                        .catch(err => console.log('err from delete', err))
                    });
            },

            async save() {
                if (!this.form.team || !this.form.locations.length) {
                    return;
                }

                await this.form.post(this.$laroute.route('spark.kiosk.healthjump.link'));
                this.fetchData();
                this.$refs.modal.close();
            }
        }
    }
</script>
